import { render } from "./PlayerListItem.vue?vue&type=template&id=48dd98f0&scoped=true&bindings={}"
import script from "./PlayerListItem.vue?vue&type=script&lang=ts"
export * from "./PlayerListItem.vue?vue&type=script&lang=ts"

import "./PlayerListItem.vue?vue&type=style&index=0&id=48dd98f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48dd98f0"

export default script